<div class="container">
  <app-page-header [title]="title">
    <ng-container backButton>
      <ng-content select="[backButton]"></ng-content>
    </ng-container>

    <ng-container buttons>
      <ng-content select="[buttons]"></ng-content>
    </ng-container>
  </app-page-header>

  @if (showDivider) {
    <hr class="my-3" />
  }

  <div [ngClass]="(breakpointService.isMobile$ | async) ? 'px-3' : 'px-5'" class="row">
    <div class="col p-0">
      <ng-content></ng-content>
    </div>
  </div>
</div>
